import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar, Footer } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { CharactersPage } from './pages/CharactersPage';
import { PricingPage } from './pages/PricingPage';
import { CreatorCompetitionPage } from './pages/CreatorCompetitionPage';
import { FundraiserPage } from './pages/FundraiserPage';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen flex flex-col bg-charcoal text-white selection:bg-lime selection:text-charcoal" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/characters" element={<CharactersPage data-id="element-8" />} data-id="element-7" />
            <Route path="/pricing" element={<PricingPage data-id="element-10" />} data-id="element-9" />
            <Route path="/creator" element={<CreatorCompetitionPage data-id="element-12" />} data-id="element-11" />
            <Route path="/fundraiser" element={<FundraiserPage data-id="element-14" />} data-id="element-13" />
          </Routes>
        </main>
        <Footer data-id="element-15" />
      </div>
    </Router>;
}